// extracted by mini-css-extract-plugin
export default {"dots":"_21l6","arrowLeft":"qbH_","pagination":"_2vmh"};